<script setup lang="ts">
import type { ItemMenu } from './types';

import { type MenuTheme, MenuItem as UIMenuItem } from '@/ui/Menu/index';

defineProps<{
  items: ItemMenu[],
  selected?: string,
  theme?: MenuTheme,
}>();
</script>
<template>
  <UIMenuItem
    :items="items"
    :selected="selected"
    :theme="theme"
  >
    <template #menu_base="{ item, baseClass }">
      <slot name="menu_base" v-bind="{ item, baseClass }">
        <MenuItemLink
          :id="item.id"
          :class="baseClass"
          :icons="item.faIcon"
          :to="item.to"
          :title="item.title"
        />
      </slot>
    </template>
    <template #menu_title="{ item, open }">
      <slot name="menu_title" v-bind="{ item, open }">
        <MenuSubItemTitle
          :icons="item.faIcon"
          :title="item.title"
          :open="open"
        />
      </slot>
    </template>
    <template #submenu_item="{ subitem, baseClass, selected: isSelected }">
      <slot name="submenu_item" v-bind="{ subitem, baseClass, selected: isSelected }">
        <MenuSubItemLink
          :id="subitem.id"
          :class="baseClass"
          :icons="subitem.faIcon"
          :to="subitem.to"
          :title="subitem.title"
          :selected="isSelected"
        />
      </slot>
    </template>
  </UIMenuItem>
</template>
